<template>
  <a-card style="margin-bottom: 20px;">
    <a-spin :spinning="loading">
      <a-form
        ref="formRef"
        :model="formState"
        name="form"
        :label-col="{ span: 4, offset: 1}"
        :wrapper-col="{ span: 7 }"
        :rules="rules"
        @finish="onFinish"
      >
        <a-form-item
          label="Status"
          name="status"
        >
          <a-radio-group
            v-model:value="formState.status"
            name="radioGroup"
          >
            <a-radio value="active">
              Active
            </a-radio>
            <a-radio value="inactive">
              Inactive
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.createTime"
          label="Create time"
        >
          <span>{{ formState.createTime ? moment(formState.createTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}</span>
        </a-form-item>
        <a-form-item
          v-if="formState.updateTime "
          label="Last update time"
        >
          <span>{{ formState.updateTime ? moment(formState.updateTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}</span>
        </a-form-item>
        <a-form-item
          label="Affiliate"
          name="affiliateId"
        >
          <a-select
            v-model:value="formState.affiliateId"
            class="max-w"
            placeholder="Select"
            :options="affiliateList"
            :disabled="!!props.item?.id"
          />
        </a-form-item>
        <!-- <a-form-item label="Affiliate PID" name="affiliatePid"
        ><a-input
            class="max-w"
            placeholder="Please enter"
            v-model:value="formState.affiliatePid"
        /></a-form-item> -->
        <a-form-item
          label="Affiliate MID"
          name="affiliateMid"
        >
          <a-input
            v-model:value="formState.affiliateMid"
            class="max-w"
            placeholder="Please enter"
            @keyup="onMidChange"
          />
        </a-form-item>
        <a-form-item
          label="Affiliate Region"
          name="affiliateRegionId"
          :rules="[{ required: affiliateList.filter(item => item.value === formState.affiliateId)[0]?.affiliateMustRegion, message: 'Please select affiliateRegion', trigger: 'change' }]"
        >
          <a-select
            v-model:value="formState.affiliateRegionId"
            class="max-w"
            allow-clear
            placeholder="Select"
            :options="regionList"
          />
        </a-form-item>
        <a-form-item
          label="Converter info"
          name="converterInfo"
          style="position: relative;"
        >
          <a-input
            v-model:value="formState.converterInfo"
            class="max-w"
            placeholder="Please enter"
            @focus="onConverFocus"
          />
          <a
            class="ant-form-text"
            target="_blank"
            style="position: absolute; right: -70px;top: 5px"
            href="https://docs.google.com/document/d/1B4VJpWhmE4KU9G7V8ASIBN1-TXZM87E9wWTS9Wr2uMw/edit?usp=sharing"
          >Guide<RightOutlined style="vertical-align: -3px;" /></a>
        </a-form-item>
        <a-form-item
          v-if="formState.commissionsOverview"
          label="Commissions Overview"
        >
          <span>{{ formState.commissionsOverview }}</span>
        </a-form-item>
        <a-form-item label="Commissions">
          <a-space
            v-for="(commRow, commIdx) in formState.commissions"
            :key="commIdx"
            align="baseline"
            style="display: flex;"
          >
            <div class="commissions-list">
              <a-form-item
                :name="['commissions', commIdx, 'id']"
                style="display: none"
              >
                <span>{{ commRow.id }}</span>
              </a-form-item>
              <a-form-item
                :label-col="{ span: 4, offset: 1 }"
                label="Name"
                :name="['commissions', commIdx, 'name']"
                :rules="{
                  required: true,
                  message: 'Please input name',
                  trigger: 'change',
                }"
              >
                <a-input
                  v-model:value="commRow.name"
                  placeholder="Name"
                  style="width: 300px"
                />
              </a-form-item>
              <a-form-item
                v-if="commRow.id && commRow.nameAuto"
                :label-col="{ span: 4, offset: 1 }"
                label="Name Auto"
                disabled
                :name="['commissions', commIdx, 'nameAuto']"
                :rules="{
                  required: true,
                }"
              >
                <a-input
                  disabled
                  :value="commRow.nameAuto"
                  style="width: 300px"
                />
              </a-form-item>
              <a-form-item
                label="Note"
                :label-col="{ span: 4, offset: 1 }"
                :name="['commissions', commIdx, 'note']"
              >
                <a-textarea
                  v-model:value="commRow.note"
                  :rows="4"
                  placeholder="Note"
                  style="width: 300px"
                />
              </a-form-item>
              <a-form-item
                label="CPA"
                :label-col="{ span: 4, offset: 1 }"
                :name="['commissions', commIdx, 'cpa']"
                :rules="{
                  required: true,
                  validator: validatorCpa,
                  trigger: 'change',
                }"
              >
                <capSelect
                  v-model="commRow.cpa"
                  :settings="settings"
                  prefix="CPA"
                />
              </a-form-item>
              <a-form-item
                label=" "
                :colon="false"
                :label-col="{ span: 4, offset: 1 }"
                :name="['commissions', commIdx, 'hasNewCpa']"
              >
                <a-checkbox
                  v-model:checked="commRow.hasNewCpa"
                >
                  New CPA
                </a-checkbox>
              </a-form-item>
              <a-form-item
                v-if="commRow.hasNewCpa"
                label="New CPA"
                :label-col="{ span: 4, offset: 1 }"
                :name="['commissions', commIdx, 'newcpa']"
                :rules="{
                  required: true,
                  validator: validatorNewCpa,
                  trigger: 'change',
                }"
              >
                <capSelect
                  v-model="commRow.newcpa"
                  :settings="settings"
                  :on-type-change="(v) => onTypeChange(v, commIdx)"
                  prefix="New CPA"
                />
              </a-form-item>
              <a-form-item
                v-if="commRow.hasNewCpa"
                label="Effective Time"
                :label-col="{ span: 4, offset: 1 }"
                :name="['commissions', commIdx, 'time']"
                :rules="{
                  required: true,
                  validator: validatorEffectiveTime,
                  trigger: 'change',
                }"
              >
                <a-range-picker
                  v-model:value="commRow.time"
                  :show-time="{ format: 'HH:mm' }"
                  format="YYYY-MM-DD HH:mm"
                  :placeholder="['Start Time', 'End Time']"
                />
              </a-form-item>
            </div>
            <a-popconfirm
              title="Are you sure you want to delete this?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="removeItem(commRow)"
              @cancel="cancel"
            >
              <MinusCircleOutlined />
            </a-popconfirm>
          </a-space>
          <a-button
            style="display: block; margin-top: 20px"
            size="small"
            @click="addCommissions"
          >
            <PlusOutlined />Add Commissions
          </a-button>
        </a-form-item>

        <a-form-item
          label="KOL rule"
          name="kolRule"
        >
          <a-radio-group
            v-model:value="formState.kolRule"
            name="kolRule"
            @change="onKolRuleChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.kolRule"
          label="RuleMode"
          name="kolRuleMode"
          :rules="ruleModeRules"
        >
          <a-radio-group
            v-model:value="formState.kolRuleMode"
            name="kolRuleMode"
            @change="onRuleModeChange"
          >
            <a-radio value="whitelist">
              WhiteList
            </a-radio>
            <a-radio value="blacklist">
              BlackList
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.kolRule && formState.kolRuleMode"
          :name="formState.kolRuleMode === 'blacklist' ? 'kolBlackListIds' : 'kolWhiteListIds'"
          label="RuleList"
          :rules="ruleListRules"
        >
          <a-select
            v-model:value="currentKolListIds"
            mode="multiple"
            label-in-value
            placeholder="Please enter"
            style="width: 400px"
            :filter-option="false"
            :not-found-content="kol.fetching ? undefined : null"
            :options="kol.data"
            :get-popup-container="(triggerNode) => triggerNode.parentNode"
            @search="searchKolWhiteList"
          >
            <template
              v-if="kol.fetching"
              #notFoundContent
            >
              <a-spin size="small" />
            </template>
          </a-select>
        </a-form-item>

        <a-form-item
          label="Affiliate Threshold"
          name="affiliateThreshold"
        >
          <a-radio-group
            v-model:value="formState.affiliateThreshold"
            name="affiliateThreshold"
            @change="onAffiliateThresholdChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.affiliateThreshold"
          label="Monthly Limit"
          name="monthlyLimit"
          :wrapper-col="{ span: 12 }"
          :rules="affiliateMonthlyLimitRules"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />This limit is triggered collectively by total sales from all influencers using this affiliate's link.
            </p>
          </template>
          <a-input-number
            v-model:value="formState.monthlyLimit"
            class="threshold-limit-input"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
            @change="onAffiliateMonthlyLimitChange"
          />
        </a-form-item>
        <a-form-item
          v-if="formState.affiliateThreshold"
          label="Daily Limit"
          name="dailyLimit"
          :wrapper-col="{ span: 12 }"
          :rules="affiliateDailyLimitRules"
        >
          <template #extra>
            <p class="subtitle">
              <ExclamationCircleOutlined style="margin-right: 5px;" />This limit is triggered collectively by total sales from all influencers using this affiliate's link.
            </p>
          </template>
          <a-input-number
            v-model:value="formState.dailyLimit"
            class="threshold-limit-input"
            :min="1"
            :precision="0"
            :step="1"
            addon-after="$"
            placeholder="Please enter"
          />
        </a-form-item>

        <a-form-item
          label="Influencer Threshold"
          name="influencerThreshold"
        >
          <a-radio-group
            v-model:value="formState.influencerThreshold"
            name="influencerThreshold"
            @change="onInfluencerThresholdChange"
          >
            <a-radio :value="true">
              Yes
            </a-radio>
            <a-radio :value="false">
              No
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="formState.influencerThreshold"
          label=" "
          :colon="false"
          :wrapper-col="{ span: 16 }"
        >
          <div class="influencer-threshold">
            <div class="influencer-threshold__toolbar">
              <a-button
                type="primary"
                @click="openInfluencerThresholdModal"
              >
                Add
              </a-button>
              <p class="subtitle influencer-threshold__tip">
                <ExclamationCircleOutlined style="margin-right: 5px;" />When Influencer Threshold is enabled, influencers in the list will be subject to this limit first.
              </p>
            </div>
            <a-table
              class="influencer-threshold__table"
              size="small"
              :pagination="false"
              :columns="influencerThresholdColumns"
              :data-source="formState.influencerThresholdList"
              row-key="influencerId"
            >
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'dailyLimit'">
                  {{ formatLimitAmount(record.dailyLimit) }}
                </template>
                <template v-else-if="column.key === 'monthlyLimit'">
                  {{ formatLimitAmount(record.monthlyLimit) }}
                </template>
                <template v-else-if="column.key === 'operation'">
                  <a-popconfirm
                    title="Are you sure you want to delete this influencer threshold?"
                    ok-text="Confirm"
                    cancel-text="Cancel"
                    @confirm="removeInfluencerThreshold(index)"
                  >
                    <a href="javascript:;">Delete</a>
                  </a-popconfirm>
                </template>
              </template>
            </a-table>
          </div>
        </a-form-item>

        <a-form-item
          label="Affiliate Note"
          name="note"
        >
          <a-textarea
            v-model:value="formState.note"
            :rows="4"
            placeholder="please enter"
          />
        </a-form-item>
        <a-form-item
          :wrapper-col="{ offset: 5, span: 16 }"
          style="margin-top: 20px"
        >
          <a-button
            type="primary"
            html-type="submit"
          >
            {{
              props.item.id ? 'Update' : 'Save'
            }}
          </a-button>
          <!-- <a-popconfirm
            :title="`Are you sure you want to cancel the ${props.item.id ? 'update' : 'new'} creation?`"
            ok-text="Yes"
            cancel-text="No"
            @confirm="onCancel"
            @cancel="cancel"
        >
        </a-popconfirm> -->
          <a-button
            style="margin-left: 10px"
            @click="onCancel"
          >
            Cancel
          </a-button>
          <a-popconfirm
            v-if="allowDelete"
            title="Are you sure you want to delete this affiliate?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteAffiliate"
            @cancel="cancel"
          >
            <a-button
              danger
              style="margin-left: 10px"
            >
              Delete
            </a-button>
          </a-popconfirm>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-card>

  <a-modal
    title="Add Influencer Threshold"
    :open="influencerThresholdModalOpen"
    :confirm-loading="influencerThresholdModalSaving"
    ok-text="OK"
    destroy-on-close
    @ok="submitInfluencerThresholdModal"
    @cancel="closeInfluencerThresholdModal"
  >
    <a-form
      ref="influencerThresholdFormRef"
      layout="vertical"
      :model="influencerThresholdForm"
    >
      <a-form-item
        label="Influencer"
        name="influencer"
        :rules="[{ required: true, message: 'Please select influencer', trigger: 'change' }]"
      >
        <a-select
          v-model:value="influencerThresholdForm.influencer"
          show-search
          label-in-value
          placeholder="Please enter"
          :filter-option="false"
          :not-found-content="thresholdKol.fetching ? undefined : null"
          :options="thresholdKol.data"
          @search="searchThresholdKol"
        >
          <template
            v-if="thresholdKol.fetching"
            #notFoundContent
          >
            <a-spin size="small" />
          </template>
        </a-select>
      </a-form-item>
      <a-form-item
        label="Daily Limit"
        name="dailyLimit"
        :rules="[{ required: false, validator: validateInfluencerDailyLimit, trigger: 'change' }]"
      >
        <a-input-number
          v-model:value="influencerThresholdForm.dailyLimit"
          :min="1"
          :precision="0"
          :step="1"
          addon-after="$"
          placeholder="Please enter"
          style="width: 100%"
        />
      </a-form-item>
      <a-form-item
        label="Monthly Limit"
        name="monthlyLimit"
        :rules="[{ required: true, validator: validateInfluencerMonthlyLimit, trigger: 'change' }]"
      >
        <a-input-number
          v-model:value="influencerThresholdForm.monthlyLimit"
          :min="1"
          :precision="0"
          :step="1"
          addon-after="$"
          placeholder="Please enter"
          style="width: 100%"
          @change="onInfluencerMonthlyLimitChange"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { ref, reactive, computed, toRaw, isProxy, createVNode, onBeforeUnmount, onMounted } from 'vue'
import { debounce } from 'lodash-es'
import { message, Modal } from 'ant-design-vue'
import { advertiser } from '../../server/index'
import { useRoute, onBeforeRouteLeave } from 'vue-router'
import {
  PlusOutlined,
  MinusCircleOutlined,
  ExclamationCircleOutlined,
  RightOutlined
} from '@ant-design/icons-vue'
import capSelect from '../../components/CpaSelect'

import moment from 'moment'
import { isEqual, cloneDeep } from 'lodash';

const props = defineProps({
  item: { type: Object, default: undefined },
  id: { type: String, default: undefined },
  allowDelete: { type: Boolean, default: false },
  onCancel: { type: Function, default: undefined },
  onComplete: { type: Function, default: undefined },
  onDelete: { type: Function, default: undefined },
})

const route = useRoute();

const regionList = ref([])
const affiliateList = ref([])

const formRef = ref(null)

const loading  = ref(false)

let id = null;

let oldData = {};


const formState = reactive({
  regionId: null,
  affiliateId: null,
  affiliateRegionId: null,
  affiliateMid: null,
  status: 'active',
  note: '',
  converterInfo: '',
  kolRule: false,
  kolRuleMode: null,
  kolWhiteListIds: [],
  kolBlackListIds: [],
  affiliateThreshold: false,
  monthlyLimit: null,
  dailyLimit: null,
  influencerThreshold: false,
  influencerThresholdList: [],
  commissions: [
    {
      name: 'Base',
      note: '',
      hasNewCpa: false,
      cpa: {
        type: 'Percent',
        value: 0
      },
    },
  ],
})
const settings = ref(null)

/** 当前 RuleMode 对应的名单，切换模式互不影响、各自保留 */
const currentKolListIds = computed({
  get() {
    return formState.kolRuleMode === 'blacklist'
      ? formState.kolBlackListIds
      : formState.kolWhiteListIds
  },
  set(val) {
    if (formState.kolRuleMode === 'blacklist') {
      formState.kolBlackListIds = val
    } else {
      formState.kolWhiteListIds = val
    }
  },
})

const kol = reactive({
  data: [],
  fetching: false,
})

function onKolRuleChange() {
  if (!formState.kolRule) {
    formState.kolRuleMode = null
    formRef.value?.clearValidate(['kolRuleMode', 'kolWhiteListIds', 'kolBlackListIds'])
  } else {
    formState.kolRuleMode = null
  }
}

function onRuleModeChange() {
  kol.data = []
  formRef.value?.clearValidate(['kolWhiteListIds', 'kolBlackListIds'])
}

const validateRuleMode = async (_rule, value) => {
  if (!formState.kolRule) return Promise.resolve()
  if (value === 'whitelist' || value === 'blacklist') return Promise.resolve()
  return Promise.reject('Please select RuleMode.')
}

const ruleModeRules = [
  {
    required: true,
    validator: validateRuleMode,
    trigger: 'change',
  },
]

const validateRuleList = async (_rule, value) => {
  if (!formState.kolRule) return Promise.resolve()
  if (Array.isArray(value) && value.length > 0) return Promise.resolve()
  return Promise.reject('Please fill in at least one infuluencer in RuleList.')
}

const ruleListRules = [
  {
    required: true,
    validator: validateRuleList,
    trigger: 'change',
  },
]

const searchKolWhiteList = debounce((keyword) => {
  kol.data = []
  kol.fetching = true
  advertiser.getKolWhiteList(keyword).then((res) => {
    kol.fetching = false
    if (res.success) {
      kol.data = (res.data || []).map((item) => ({
        label: item.userName,
        value: item.id,
      }))
    } else {
      message.error('获取KOL白名单失败，请重试')
    }
  })
}, 300)

const influencerThresholdModalOpen = ref(false)
const influencerThresholdModalSaving = ref(false)
const influencerThresholdFormRef = ref(null)
const influencerThresholdForm = reactive({
  influencer: null,
  dailyLimit: null,
  monthlyLimit: null,
})
const thresholdKol = reactive({
  data: [],
  fetching: false,
})
const influencerThresholdColumns = [
  { title: 'Influencer', dataIndex: 'influencerName', key: 'influencerName' },
  { title: 'DailyLimit', dataIndex: 'dailyLimit', key: 'dailyLimit' },
  { title: 'MonthlyLimit', dataIndex: 'monthlyLimit', key: 'monthlyLimit' },
  { title: 'Operation', key: 'operation', width: 100 },
]

const validateAffiliateLimit = async (_rule, value) => {
  if (!formState.affiliateThreshold) return Promise.resolve()
  if (value == null || value === '') {
    return Promise.reject('Please enter a positive integer.')
  }
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer.')
  }
  return Promise.resolve()
}

const validateAffiliateDailyLimit = async (_rule, value) => {
  if (!formState.affiliateThreshold) return Promise.resolve()
  // Daily Limit 非必填
  if (value == null || value === '') return Promise.resolve()
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer.')
  }
  if (
    formState.monthlyLimit != null &&
    formState.monthlyLimit !== '' &&
    Number(value) > Number(formState.monthlyLimit)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

const validateAffiliateMonthlyLimit = async (_rule, value) => {
  await validateAffiliateLimit(_rule, value)
  if (
    formState.dailyLimit != null &&
    formState.dailyLimit !== '' &&
    Number(formState.dailyLimit) > Number(value)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

function onAffiliateMonthlyLimitChange() {
  Promise.resolve().then(() => {
    formRef.value?.validateFields(['dailyLimit']).catch(() => {})
  })
}

const affiliateDailyLimitRules = [
  {
    required: false,
    validator: validateAffiliateDailyLimit,
    trigger: 'change',
  },
]

const affiliateMonthlyLimitRules = [
  {
    required: true,
    validator: validateAffiliateMonthlyLimit,
    trigger: 'change',
  },
]

function onAffiliateThresholdChange() {
  if (!formState.affiliateThreshold) {
    formState.monthlyLimit = null
    formState.dailyLimit = null
    formRef.value?.clearValidate(['monthlyLimit', 'dailyLimit'])
  }
}

function onInfluencerThresholdChange() {
  if (!formState.influencerThreshold) {
    formState.influencerThresholdList = []
    closeInfluencerThresholdModal()
  }
}

function formatLimitAmount(value) {
  if (value == null || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  return `$ ${num.toFixed(2)}`
}

function resetInfluencerThresholdForm() {
  influencerThresholdForm.influencer = null
  influencerThresholdForm.dailyLimit = null
  influencerThresholdForm.monthlyLimit = null
  thresholdKol.data = []
  thresholdKol.fetching = false
}

function openInfluencerThresholdModal() {
  resetInfluencerThresholdForm()
  influencerThresholdModalOpen.value = true
}

function closeInfluencerThresholdModal() {
  influencerThresholdModalOpen.value = false
  influencerThresholdModalSaving.value = false
  resetInfluencerThresholdForm()
}

function validateInfluencerLimitValue(value, affiliateLimit, label) {
  if (value == null || value === '') {
    return Promise.reject(`Please enter ${label}.`)
  }
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject(`Please enter a positive integer for ${label}.`)
  }
  if (
    formState.affiliateThreshold &&
    affiliateLimit != null &&
    Number(value) > Number(affiliateLimit)
  ) {
    return Promise.reject(
      `${label} cannot exceed Affiliate ${label} ($${affiliateLimit}).`
    )
  }
  return Promise.resolve()
}

const validateInfluencerDailyLimit = async (_rule, value) => {
  // Daily Limit 非必填
  if (value == null || value === '') return Promise.resolve()
  if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
    return Promise.reject('Please enter a positive integer for Daily Limit.')
  }
  if (
    formState.affiliateThreshold &&
    formState.dailyLimit != null &&
    Number(value) > Number(formState.dailyLimit)
  ) {
    return Promise.reject(
      `Daily Limit cannot exceed Affiliate Daily Limit ($${formState.dailyLimit}).`
    )
  }
  const monthlyLimit = influencerThresholdForm.monthlyLimit
  if (
    monthlyLimit != null &&
    monthlyLimit !== '' &&
    Number(value) > Number(monthlyLimit)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

const validateInfluencerMonthlyLimit = async (_rule, value) => {
  await validateInfluencerLimitValue(value, formState.monthlyLimit, 'Monthly Limit')
  const dailyLimit = influencerThresholdForm.dailyLimit
  if (
    dailyLimit != null &&
    dailyLimit !== '' &&
    Number(dailyLimit) > Number(value)
  ) {
    return Promise.reject('Daily limit can not exceed monthly limit.')
  }
  return Promise.resolve()
}

function onInfluencerMonthlyLimitChange() {
  Promise.resolve().then(() => {
    influencerThresholdFormRef.value?.validateFields(['dailyLimit']).catch(() => {})
  })
}

async function submitInfluencerThresholdModal() {
  try {
    await influencerThresholdFormRef.value?.validate()
  } catch (e) {
    if (!e?.errorFields?.length && e?.outOfDate) {
      // continue
    } else {
      return Promise.reject(e)
    }
  }

  const influencer = influencerThresholdForm.influencer
  const influencerId = influencer?.value
  if (
    formState.influencerThresholdList.some(
      (item) => String(item.influencerId) === String(influencerId)
    )
  ) {
    message.error('This influencer is already in the list.')
    return Promise.reject(new Error('duplicate'))
  }

  formState.influencerThresholdList.push({
    influencerId,
    influencerName: influencer?.label || String(influencerId),
    dailyLimit:
      influencerThresholdForm.dailyLimit == null || influencerThresholdForm.dailyLimit === ''
        ? null
        : Number(influencerThresholdForm.dailyLimit),
    monthlyLimit: Number(influencerThresholdForm.monthlyLimit),
  })
  closeInfluencerThresholdModal()
}

function removeInfluencerThreshold(index) {
  formState.influencerThresholdList.splice(index, 1)
}

const searchThresholdKol = debounce((keyword) => {
  thresholdKol.data = []
  thresholdKol.fetching = true
  advertiser.getKolWhiteList(keyword).then((res) => {
    thresholdKol.fetching = false
    if (res.success) {
      thresholdKol.data = (res.data || []).map((item) => ({
        label: item.userName,
        value: item.id,
      }))
    } else {
      message.error('Failed to search influencer, please try again.')
    }
  })
}, 300)

const validatorCpa = async (r, v) => {
    console.log(v);
    if(v?.value === '' || v?.value === null) {
        return Promise.reject('Please input cpa value');
    } else {
        return Promise.resolve();
    }
}

const validatorNewCpa = async (r, v) => {
    console.log(v);
    if(v?.value === '' || v?.value === null) {
        return Promise.reject('Please input newcpa value');
    } else {
        return Promise.resolve();
    }
}

const validatorEffectiveTime = async(r, v) => {
    if(!v) {
        return Promise.reject('Please select newcpa effective time');
    } else if(toRaw(v[1]).isBefore(moment().startOf('day'))) {
        return Promise.reject('It has expired, please modify it');
    } else {
        return Promise.resolve();
    }
}

const onTypeChange = (v, index) => {
    if (v === 'Up to Amount' || v === 'Amount') {
        formState.commissions[index].newcpa.currencyName = toRaw(formState.commissions[index])?.cpa.currencyName;
    }
}

const hasDataChanged = () => {
    return isEqual(toRaw(formState), oldData);
}

// MID不能输入空格
function onMidChange(e) {
    formState.affiliateMid = e.target.value.replace(/\s/g, '')
}


const rules = {
  affiliateId: [{ required: true, message: 'Please select affiliate', trigger: 'change' }],
//   affiliatePid: [{ required: true, message: 'Please input affiliate pid', trigger: 'change' }],
  affiliateMid: [{ required: true, message: 'Please input affiliate mid', trigger: 'change' }],
  converterInfo: [{ required: true, message: 'Please input converter info', trigger: 'change' }]
};

const onCancel = () => {
    if (!hasDataChanged()) {
        Modal.confirm({
            title: 'Confirm',
            icon: createVNode(ExclamationCircleOutlined),
            content: `Are you sure you want to cancel ${props.item.id ? 'these changes' : 'the new creation'} ?`,
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                props.onCancel(props.item.id);
            }
        });
    } else {
        props.onCancel(props.item.id);
    }
}

const deleteAffiliate =() => {
    advertiser.deleteAffiliate(props.item.id).then(res => {
        if(res.success) {
            message.success('success!')
            props.onDelete();
        } else {
            message.error(res.error)
        }
    })
}

const onConverFocus = (e) => {
    if((formState.affiliateId == 1 || formState.affiliateId == 5) && !e.target.value) {
        formState.converterInfo = formState.affiliateMid;
    }
}

const handleBeforeUnload = (event) => {
    if (!hasDataChanged()) { 
        event.preventDefault();
        event.returnValue = ''; // 显示默认的确认提示框
    }
};

const showConfirm = (next) => {
    if (!hasDataChanged()) {
        Modal.confirm({
            title: 'Confirm',
            icon: createVNode(ExclamationCircleOutlined),
            content: `Are you sure you want to cancel ${props.item.id ? 'these changes' : 'the new creation'} ?`,
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                next();
            }
        });
    } else {
        next(); 
    }
};

// 路由离开守卫
const setupRouteGuard = () => {
    console.log(1111);
    onBeforeRouteLeave((to, from, next) => {
    if (to.path !== route.path) {
        showConfirm(next);
    } else {
        next();
    }
    });
};


onMounted(() => {
    setupRouteGuard(); // 设置路由离开守卫
    window.addEventListener('beforeunload', handleBeforeUnload); // 添加刷新/关闭监听
});

onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload); // 组件销毁时移除监听
});

const init = async() => {
  loading.value = true;
  const p1 = advertiser.getSettingsInfo().then((res) => {
    settings.value = res.data
  })
  const p2 = advertiser.getAffiliateRegionList().then(res => {
    regionList.value = res.data.map(item => {
        return {
            value: item.id,
            label: item.name,
        }
    })
  });
  const p3 = advertiser.getAffiliateList().then(res => {
    affiliateList.value = res.data.map(item => {
        return {
            value: item.id,
            label: item.name,
            affiliateMustRegion: item.affiliateMustRegion
        }
    })
  })
  await Promise.all([p1, p2, p3]);
  loading.value = false;
  let backData = {...toRaw(props.item)};
  if (backData.id) {
    id = backData.id;
    backData.commissions = backData.commissions ? backData.commissions.map((item) => {
          let cpa = {}
          let newcpa = {}
          cpa.type = item.type
          cpa.value = item.value
          cpa.currencyName = item.currencyName
          if (item.hasNewCpa) {
            newcpa.type = item.newCpaType
            newcpa.value = item.newCpaValue
            newcpa.currencyName = item.newCpaCurrencyName
          }
          return {
            time: item.hasNewCpa
              ? [moment(item.newCpaBeginTime), moment(item.newCpaEndTime)]
              : undefined,
            id: item.id,
            hasNewCpa: item.hasNewCpa,
            name: item.name,
            nameAuto: item.nameAuto,
            note: item.note,
            cpa: cpa,
            newcpa: newcpa,
          }
        }) : [];
        const mapKolList = (list) =>
          (list || []).map((item) => ({
            label: item.name || item.userName,
            value: item.id,
          }))
        backData.kolWhiteListIds = mapKolList(backData.kolWhiteList)
        backData.kolBlackListIds = mapKolList(backData.kolBlackList)
        backData.kolRuleMode = backData.kolRuleMode || backData.ruleMode || null
        if (backData.kolRuleMode) {
          backData.kolRuleMode = String(backData.kolRuleMode).toLowerCase()
        }
        backData.kolRule = !!backData.kolRule
        if (!backData.kolRule) {
          backData.kolRuleMode = null
        }
        delete backData.kolWhiteList
        delete backData.kolBlackList
        delete backData.ruleMode

        const rawSalesThreshold = backData.salesThreshold
        const salesThreshold =
          rawSalesThreshold && typeof rawSalesThreshold === 'object' ? rawSalesThreshold : {}
        backData.affiliateThreshold = !!salesThreshold.scopeEnabled
        backData.dailyLimit = salesThreshold.dailyLimit ?? null
        backData.monthlyLimit = salesThreshold.monthlyLimit ?? null
        backData.influencerThreshold = !!salesThreshold.influencerEnabled
        backData.influencerThresholdList = (Array.isArray(salesThreshold.items)
          ? salesThreshold.items
          : []
        ).map((item) => ({
          influencerId: item.influencerId ?? item.id,
          influencerName:
            item.influencerName || item.userName || item.name || String(item.influencerId ?? item.id),
          dailyLimit: item.dailyLimit,
          monthlyLimit: item.monthlyLimit,
        }))
        if (!backData.affiliateThreshold) {
          backData.monthlyLimit = null
          backData.dailyLimit = null
        }
        if (!backData.influencerThreshold) {
          backData.influencerThresholdList = []
        }
        delete backData.salesThreshold
        Object.assign(formState, backData)
  }
  oldData = cloneDeep(toRaw(formState));
}

const removeItem = (item) => {
  const index = formState.commissions.indexOf(item)
  if (index !== -1) {
    formState.commissions.splice(index, 1)
  }
}



const addCommissions = () => {
    let default_check = false;
    let default_time = undefined;
    if(formState.commissions.length >= 1) {
        default_check = formState.commissions[0].hasNewCpa;
        default_time = formState.commissions[0].hasNewCpa ? formState.commissions[0].time : undefined;
    }
    formState.commissions.push({
        name: 'Base',
        note: '',
        hasNewCpa: default_check,
        cpa: {
            type: 'Percent',
            value: 0,
        },
        time: default_time
    })
}

const onFinish = (values) => {
  let arraylist = []
  if (props.id) {
    values.advertiserId = props.id
  }
  if (id) {
    values.id = id;
  }
  let currencies = [];
  values.commissions?.map((item) => {
    let obj = {}
    const cpa = isProxy(item.cpa) ? toRaw(item.cpa) : item.cpa
    obj.value = cpa.value
    obj.type = cpa.type
    obj.name = item.name
    obj.note = item.note
    obj.currencyName = cpa.currencyName
    obj.hasNewCpa = item.hasNewCpa
    obj.id = item.id
    currencies.push(obj.currencyName);
    if (obj.hasNewCpa) {
      {
        const time = isProxy(item.time) ? toRaw(item.time) : item.time
        const newcpa = isProxy(item.newcpa) ? toRaw(item.newcpa) : item.newcpa
        obj.newCpaType = newcpa.type
        obj.newCpaValue = newcpa.value
        obj.newCpaBeginTime = time && time[0].format('x')
        obj.newCpaEndTime = time && time[1].format('x')
        obj.newCpaCurrencyName = newcpa.currencyName
        currencies.push(obj.newCpaCurrencyName);
      }
    }
    arraylist.push(obj)
  })
  const cleanArray = currencies.filter(item => item !== null && item !== undefined && item !== '');
  const areAllSame = cleanArray.every(item => item === cleanArray[0]);
  if(!areAllSame) {
    message.error('Please ensure that the currencies of all commissions are consistent.');
    return false;
  }
  values.commissions = arraylist;
  const mapIds = (list) => {
    const raw = isProxy(list) ? toRaw(list) : list
    return raw?.map((item) => item.value) || []
  }
  values.kolRule = !!formState.kolRule
  values.kolRuleMode = formState.kolRule ? formState.kolRuleMode : null
  if (values.kolRule && values.kolRuleMode === 'blacklist') {
    values.kolBlackListIds = mapIds(formState.kolBlackListIds)
    values.kolWhiteListIds = []
  } else if (values.kolRule) {
    values.kolWhiteListIds = mapIds(formState.kolWhiteListIds)
    values.kolBlackListIds = []
  } else {
    values.kolWhiteListIds = []
    values.kolBlackListIds = []
  }
  const scopeEnabled = !!formState.affiliateThreshold
  const influencerEnabled = !!formState.influencerThreshold
  values.salesThreshold = {
    scopeEnabled,
    dailyLimit: scopeEnabled ? formState.dailyLimit : null,
    monthlyLimit: scopeEnabled ? formState.monthlyLimit : null,
    influencerEnabled,
    items: influencerEnabled
      ? toRaw(formState.influencerThresholdList).map((item) => ({
          influencerId: item.influencerId,
          dailyLimit: item.dailyLimit,
          monthlyLimit: item.monthlyLimit,
        }))
      : [],
  }
  delete values.affiliateThreshold
  delete values.dailyLimit
  delete values.monthlyLimit
  delete values.influencerThreshold
  delete values.influencerThresholdList
  advertiser.addAffiliate(values).then((res) => {
    if (res.success) {
      message.info('Affiliate info save success!')
    //   formState.commissionsOverview = res.data.commissionsOverview
      props.onComplete(res.data);
    } else {
      message.error(res.error);
    }
  })
}

init()
</script>

<style lang="less" scoped>
.commissions-list {
  background-color: #f5f5f5;
  border-radius: 10px;
  width: 750px;
  margin-top: 20px;
  border: 1px solid #eee;
}
.avatar {
  max-width: 100%;
}
.subtitle {
  color: #999;
  margin: 3px 0 0;
}
.threshold-limit-input {
  width: 320px;
}
.influencer-threshold {
  width: 100%;
  max-width: 960px;
}
.influencer-threshold__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.influencer-threshold__tip {
  margin: 0;
}
.influencer-threshold__table {
  :deep(.ant-table) {
    background: #fff;
  }
}
.label {
    color: #666;
}
.ant-space-item {
    .anticon {
        vertical-align: 30px;
    }   
}
</style>